module.exports = __webpack_public_path__ + "assets/game-type-missing-character.a53b2f43.svg";